import { getClinicPreferences } from '../services/api';

export const DEFAULT_TIME_ZONE = 'America/Guatemala';

/** The clinic's IANA time zone, or the default when it cannot be read. */
export const fetchClinicTimeZone = (): Promise<string> =>
  getClinicPreferences()
    .then((prefs) => prefs.timezone || DEFAULT_TIME_ZONE)
    .catch(() => DEFAULT_TIME_ZONE);
